import axiosInstance from './axios';
import { OBSERVATIONS_SCREEN } from './api_routes';

export function hasObsProjectId() {
    const projectId = typeof localStorage === 'undefined' ? null : localStorage.getItem('project_id');
    return Boolean(projectId) && projectId !== 'null' && projectId !== 'undefined';
}

function readProjectId() {
    if (!hasObsProjectId()) return null;
    return localStorage.getItem('project_id');
}

function missingProjectError() {
    const error = new Error('Select a project.');
    error.response = { status: 400, data: { detail: 'Select a project.' } };
    return error;
}

function projectPath(suffix) {
    const projectId = readProjectId();
    return `${OBSERVATIONS_SCREEN}${projectId}/${suffix}`;
}

async function request(method, suffix, data, config) {
    if (!readProjectId()) {
        return Promise.reject(missingProjectError());
    }
    const response = await axiosInstance({
        method,
        url: projectPath(suffix),
        data,
        ...config,
    });
    return response.data;
}

export function getObsScreen() {
    return request('get', 'screen/');
}

export function createObsRecord(body) {
    return request('post', 'screen/', body);
}

export function getObsRecord(id) {
    return request('get', `screen/${encodeURIComponent(id)}/`);
}

export function updateObsRecord(id, body) {
    return request('patch', `screen/${encodeURIComponent(id)}/`, body);
}

export function bulkUpdateObsRecords(body) {
    return request('post', 'screen-bulk-update/', body || {});
}

export function bulkDeleteObsRecords(body) {
    return request('post', 'screen-bulk-delete/', body || {});
}

export function bulkImportObsRecords(body) {
    return request('post', 'screen-bulk-import/', body || {});
}

export function postObsComment(id, comment, parent, mentions) {
    return request('post', `screen/${encodeURIComponent(id)}/comment/`, { comment, parent, mentions });
}

export function editObsComment(id, commentId, comment, mentions) {
    return request('post', `screen/${encodeURIComponent(id)}/comment/${commentId}/edit/`, {
        comment,
        mentions: mentions || [],
    });
}

export function deleteObsComment(id, commentId) {
    return request('post', `screen/${encodeURIComponent(id)}/comment/${commentId}/delete/`);
}

export function resolveObsComment(id, commentId) {
    return request('post', `screen/${encodeURIComponent(id)}/comment/${commentId}/resolve/`);
}

export function reopenObsComment(id, commentId) {
    return request('post', `screen/${encodeURIComponent(id)}/comment/${commentId}/reopen/`);
}

export function resolveObsRecord(id, note) {
    return request('post', `screen/${encodeURIComponent(id)}/resolve/`, { note: note || '' });
}

export function supersedeObsRecord(id, replacement, reason) {
    return request('post', `screen/${encodeURIComponent(id)}/supersede/`, {
        superseded_by: replacement,
        reason: reason || '',
    });
}

export function archiveObsRecord(id) {
    return request('post', `screen/${encodeURIComponent(id)}/archive/`);
}

export function dismissObsImpact(id) {
    return request('post', `screen/${encodeURIComponent(id)}/dismiss-impact/`);
}

export function analyseObsUpdate(id) {
    return request('post', `screen/${encodeURIComponent(id)}/analyse-update/`);
}

export function uploadObsEvidence(id, files) {
    const form = new FormData();
    Array.from(files || []).forEach(file => form.append('files', file));
    return request('post', `screen/${encodeURIComponent(id)}/evidence/`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
}

export function openObsEvidence(openUrl) {
    return axiosInstance.get(openUrl).then(response => response.data);
}

export function createObsFollowUpIrl(id, body) {
    return request('post', `screen/${encodeURIComponent(id)}/follow-up-irl/`, body || {});
}

export function markObsDiscussionRead(id) {
    return request('post', `screen/${encodeURIComponent(id)}/read/`);
}
